import { render, staticRenderFns } from "./RcvN_Items.vue?vue&type=template&id=ea60ef70"
import script from "./RcvN_Items.vue?vue&type=script&lang=js"
export * from "./RcvN_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports